import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b'
import posthog from 'posthog-js'

let stytchClient: StytchB2BUIClient | null = null
const publicToken = import.meta.env.VITE_STYTCH_PUBLIC_TOKEN

export function getStytchClient(): StytchB2BUIClient {
  if (stytchClient) return stytchClient

  stytchClient = new StytchB2BUIClient(publicToken)
  stytchClient.member.getSync()
  return stytchClient
}

export function getSessionInfo() {
  const stytch = getStytchClient()
  if (stytch.session.getSync()) {
    const tokens = stytch.session.getTokens()
    const member = stytch.member.getSync()
    const organization = stytch.organization.getSync()
    return { member, tokens, organization }
  }
  return null
}

export function logoutUser() {
  // drop the identified person so the next login (or the marketing site) doesn't inherit it;
  // reset() also clears consent, so keep an admin's opt-out
  const optedOut = posthog.has_opted_out_capturing()
  posthog.reset()
  if (optedOut) posthog.opt_out_capturing()
  return getStytchClient().session.revoke()
}

export function getStytchOrganizationUrl(organizationId: string): string {
  return `https://stytch.com/dashboard/organizations?organization_id=${organizationId}&project_id=${import.meta.env.VITE_STYTCH_PROJECT_ID}`
}
